import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable()
export class AlertService {

  constructor(private translateService: TranslateService) {
  }

  public showDeleteWarning(): Promise<boolean> {
    let promise = new Promise<boolean>((resolve, reject) => {
      swal({
        titleText: this.translateService.instant('alert.deleteWarning.title'),
        text: this.translateService.instant('alert.deleteWarning.message'),
        type: 'warning',
        showCancelButton: true,
        focusCancel: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.translateService.instant('common.delete')
      })
      .then(
        () => resolve(true)
      )
      .catch(
        (dismiss) => resolve(false)
      );
    });

    return promise;
  }

  public warning(titleKey: string , messageKey: string) {
    let promise = new Promise<boolean>((resolve, reject) => {
      swal({
        titleText: this.translateService.instant(titleKey),
        text: this.translateService.instant(messageKey),
        type: 'warning',
        focusCancel: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.translateService.instant('common.ok')
      })
      .then(
        () => resolve(true)
      )
      .catch(
        (dismiss) => resolve(false)
      );
    });

    return promise;
  }

  public showError(error: Parse.Error): void {
    swal({
      titleText: this.translateService.instant('alert.error.title'),
      text: error.message,
      type: 'error',
      timer: 2000,
      confirmButtonText: this.translateService.instant('common.ok').toUpperCase()
    })
    .catch((dismiss) => {
      // empty catch to prevent warning
    });
  }

  public swal(settings: SweetAlertOptions): Promise<any> {
    return swal(settings);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/alert/alert.service.ts